import { Card, CardContent, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React from 'react'

import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import classNames from 'classnames'

const useStyles = makeStyles((theme) => ({
	card: {
		position: 'relative',
		height: 175,
		border: 'none',
		transition: 'color 0.3s, border 0.3s, box-shadow 0.3s',
		color: 'black !important',
		'&:hover': {
			color: theme.palette.secondary.main + ' !important',
			border: 'solid 1px rgba(102, 153, 255,0.4)',
			boxShadow: '0px 10px 24px 0px rgba(0,0,0,0.2)',
			transition: 'color 0.3s, border 0.3s, box-shadow 0.3s',
		},
		'&:hover $title': {
			color: theme.palette.secondary.main + ' !important',
			transition: 'color 0.3s',
		},
		'.external &': {
			background: theme.palette.secondary.main,
		},
		'.external:hover &': {
			background: theme.palette.primary.main,
		},
	},
	title: {
		margin: theme.spacing.unit,
		fontSize: '1.2em',
		textAlign: 'center',
		[theme.breakpoints.down('md')]: {
			margin: 5,
		},
		'.external &': {
			color: theme.palette.primary.main + ' !important',
		},
		'.external:hover &': {
			color: theme.palette.secondary.main + ' !important',
		},
	},
	icon: {
		position: 'absolute',
		display: 'block',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -50%)',
		fontSize: 60,
		'.external &': {
			color: theme.palette.primary.main + ' !important',
		},
		'.external:hover &': {
			color: theme.palette.secondary.main + ' !important',
		},
	},
	link: {
		display: 'contents',
		textDecoration: 'none',
		'&:visited': {
			color: 'black',
		},
	},
	error: {
		border: `solid 1px red`,
	},
}))

function OICard({ title, icon: Icon, link, external = false, error = false, onClick }) {
	const classes = useStyles()

	return (
		<Grid md={4} xs={12} item className={external ? 'external' : ''}>
			{external && onClick ? (
				<a className={classes.link} href="#" target="_blank" rel="noopener noreferrer" onClick={e => { e.preventDefault(); onClick(); }}>
					<Card
						className={classNames({
							[classes.error]: error,
							[classes.card]: true,
						})}
					>
						<CardContent>
							<Typography className={classes.title} variant="h6">
								{title}
							</Typography>
							{Icon && <Icon className={classes.icon} />}
						</CardContent>
					</Card>
				</a>
			) : (
				<Link className={classes.link} to={link} target={external ? '_blank' : '_self'}>
					<Card
						className={classNames({
							[classes.error]: error,
							[classes.card]: true,
						})}
					>
						<CardContent>
							<Typography className={classes.title} variant="h6">
								{title}
							</Typography>
							{Icon && <Icon className={classes.icon} />}
						</CardContent>
					</Card>
				</Link>
			)}
		</Grid>
	)
}
OICard.propTypes = {
	title: PropTypes.string,
	icon: PropTypes.func,
	link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	external: PropTypes.bool,
	error: PropTypes.bool,
	onClick: PropTypes.func,
}

export default OICard
